var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTableCol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2871_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4672 26.603C10.8693 26.603 8.32974 25.8326 6.16968 24.3893C4.00962 22.946 2.32606 20.8946 1.33189 18.4944C0.337722 16.0943 0.0776031 13.4533 0.584425 10.9053C1.09125 8.35734 2.34225 6.01688 4.17923 4.1799C6.01621 2.34292 8.35667 1.09192 10.9046 0.585096C13.4526 0.0782745 16.0936 0.338394 18.4938 1.33256C20.8939 2.32673 22.9453 4.01029 24.3886 6.17035C25.8319 8.33041 26.6023 10.87 26.6023 13.4678C26.6023 16.9515 25.2184 20.2925 22.7551 22.7558C20.2918 25.2191 16.9508 26.603 13.4672 26.603ZM13.4672 1.9746C11.194 1.9746 8.97192 2.64867 7.08187 3.91156C5.19181 5.17445 3.7187 6.96945 2.8488 9.06957C1.9789 11.1697 1.7513 13.4806 2.19477 15.7101C2.63824 17.9395 3.73286 19.9874 5.34022 21.5948C6.94758 23.2021 8.99548 24.2968 11.2249 24.7402C13.4544 25.1837 15.7653 24.9561 17.8654 24.0862C19.9656 23.2163 21.7606 21.7432 23.0235 19.8531C24.2863 17.9631 24.9604 15.741 24.9604 13.4678C24.9604 10.4196 23.7495 7.49629 21.5941 5.34089C19.4387 3.18549 16.5154 1.9746 13.4672 1.9746Z",
    fill: "#41D928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02539 13.573L11.9659 17.5136L18.5335 10.946",
    stroke: "#41D928",
    strokeWidth: 1.97027,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2871_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTableCol);
export default __webpack_public_path__ + "static/media/add-table-col.ce0ed7d5da1ed40abc817b241957242c.svg";
export { ForwardRef as ReactComponent };